<template>
  <div class="eject-dialog-content">
    <div class="eject-dialog-body">
      <img
        @click="closeClick"
        class="close-icon"
        src="https://cdn.huomaqun.com/material/2024-01-25/787986a00e2977d9bbbe829b11c47b0e.png"
        alt=""
      />
      <div ref="wrapper">
        <div>
          <video
            v-if="!cutUrl"
            ref="videoEl"
            class="videoEl"
            style="width: 100%; height: calc(100vh - 165px);transform:rotateY(180deg);"
            muted
            playsinline
          ></video>
        </div>
        <img
          :src="cutUrl"
          alt=""
          v-if="cutUrl"
          style="width: 100%; height: calc(100vh - 165px);object-fit: cover"
        />
        <div class="shoot-btn-box">
          <div class="shoot-btn" @click="cutUrl ? upload() : shoot()">
            <div class="shoot-btn-circle" :class="{ active: cutUrl }">
              {{ cutUrl ? "确定" : "拍摄" }}
            </div>
          </div>
          <div v-if="cutUrl" class="reTake" @click="reTake">
            <img
              class="reTake-icon"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211111/701584ac2a75ec8b747714cef59a5f05.png"
              alt=""
            />
            <div>重拍</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cutUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return{}
  },
  methods: {
    closeClick() {
      this.$emit('closeClick')
    },
    reTake() {
      this.$emit('reTake')
    },
    upload() {
      this.$emit('upload')
    },
    shoot() {
      const canvas = document.createElement("canvas");
      canvas.width = this.$refs.videoEl.videoWidth;
      canvas.height = this.$refs.videoEl.videoHeight;
      //拿到 canvas 上下文对象
      const ctx = canvas.getContext("2d");
      // 进行旋转变换
      ctx.scale(-1, 1); 
      ctx.drawImage(this.$refs.videoEl, -canvas.width, 0, canvas.width, canvas.height);
      this.$emit('handleShoot',  {
        url: canvas.toDataURL("image/png"),
        canvas: canvas
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.eject-dialog-content {
  width: 100%;
  background: transparent;
  margin: 0 auto;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  border-radius: 10px 10px 0 0;
}

.eject-dialog-body {
  position: relative;
  width: 100%;
  max-width: 500px;
  background-color: #ffffff;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
  padding-bottom: safe-area-inset-bottom;
}
.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  z-index: 100;
}
.videoEl {
  border-radius: 10px 10px 0 0;
  object-fit: cover;
}
.videoEl-copy {
  width: 100%;
  position: absolute;
  z-index: 99;
  right: 30000px;
}
.shoot-btn-box {
  height: 105px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.shoot-btn {
  border: 3px solid #1890ff;
  width: 75px;
  height: 75px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
}
.shoot-btn-circle {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #1890ff;
  font-size: 14px;
  color: #1890ff;
  border-radius: 50%;
}
.shoot-btn-circle.active {
  background: #1890ff;
  color: #ffffff;
}
.reTake {
  position: absolute;
  right: 30px;
  font-size: 14px;
  cursor: pointer;
}
.reTake-icon {
  width: 25px;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/camera.vue